"use client";

import React, { ReactNode, createContext, useState } from "react";

interface Product {
  // Define product shape here or leave as any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [key: string]: any;
}

interface NavContextType {
  isMobileNavOpen: boolean;
  setIsMobileNavOpen: (bool: boolean) => void;
  isPageScrolled: boolean;
  setIsPageScrolled: (bool: boolean) => void;
  showPdpAtc: boolean;
  setShowPdpAtc: (bool: boolean) => void;
  selectedProduct: Product | undefined;
  setSelectedProduct: (productObj: Product | undefined) => void;
  availableProducts: Product[] | undefined;
  setAvailableProducts: (optionsArr: Product[] | undefined) => void;
}

const defaultState: NavContextType = {
  isMobileNavOpen: false,
  setIsMobileNavOpen: () => {},
  isPageScrolled: false,
  setIsPageScrolled: () => {},
  showPdpAtc: false,
  setShowPdpAtc: () => {},
  selectedProduct: undefined,
  setSelectedProduct: () => {},
  availableProducts: undefined,
  setAvailableProducts: () => {},
};

const NavContext = createContext<NavContextType>(defaultState);

interface NavProviderProps {
  children: ReactNode;
}

const NavProvider = ({ children }: NavProviderProps) => {
  const [isMobileNavOpen, setIsMobileNavOpenState] = useState(false);
  const [isPageScrolled, setIsPageScrolledState] = useState(false);
  const [showPdpAtc, setShowPdpAtc] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<Product | undefined>(undefined);
  const [availableProducts, setAvailableProducts] = useState<Product[] | undefined>(undefined);

  const setIsMobileNavOpen = (bool: boolean) => {
    document.body.classList.toggle("no-scroll", bool);
    setIsMobileNavOpenState(bool);
  };

  const setIsPageScrolled = (bool: boolean) => {
    document.body.classList.toggle("pagescrolled", bool);
    setIsPageScrolledState(bool);
  };

  return (
    <NavContext.Provider
      value={{
        isMobileNavOpen,
        setIsMobileNavOpen,
        isPageScrolled,
        setIsPageScrolled,
        showPdpAtc,
        setShowPdpAtc,
        selectedProduct,
        setSelectedProduct,
        availableProducts,
        setAvailableProducts,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};

export default NavContext;
export { NavProvider };
